export const TEMPLATE_FILE_URL = {
  REFERENCE: "spreadsheet-template/deployment-request-detail-reference.xlsx",
  DEPLOYMENT_SETUP_PENDING:
    "spreadsheet-template/deployment-request-detail-pending.xlsx",
};

export const INTERRUPT_TYPE_PENDING = "Pending";
